/**
 * useDIOCBadge — polls /api/admin/dq/critical-count for the sidebar
 * red-alert badge. Only issues requests for Super_Admin / Academic_
 * Supervisor roles; anyone else gets a noop hook so we don't spam
 * 403s or waste requests.
 *
 * Poll cadence: 60 s (light endpoint — only counts, no PII).
 */
import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 60_000;

export const useDIOCBadge = (userRole) => {
  const [count, setCount] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const eligible = userRole === 'Super_Admin'
                  || userRole === 'Academic_Supervisor';
    if (!eligible) { setCount(0); return; }

    let cancelled = false;

    const fetchOnce = async () => {
      try {
        const r = await axios.get(`${API}/api/admin/dq/critical-count`, {
          withCredentials: true, timeout: 8000,
        });
        if (!cancelled) setCount(r.data.badge_count || 0);
      } catch {
        // silent — badge is best-effort
      }
    };

    fetchOnce();
    timerRef.current = setInterval(() => { if (!document.hidden) fetchOnce(); }, POLL_MS);
    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [userRole]);

  return count;
};
